// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const Asset = __t.object("Asset", {
  assetId: __t.u64(),
  scope: __t.string(),
  get category() {
    return AssetCategory;
  },
  name: __t.string(),
  description: __t.string(),
  tags: __t.string(),
  thumbnailUrl: __t.option(__t.string()),
  format: __t.option(__t.string()),
  boundsMinX: __t.option(__t.f64()),
  boundsMinY: __t.option(__t.f64()),
  boundsMinZ: __t.option(__t.f64()),
  boundsMaxX: __t.option(__t.f64()),
  boundsMaxY: __t.option(__t.f64()),
  boundsMaxZ: __t.option(__t.f64()),
  get placement() {
    return AssetPlacement;
  },
  isGround: __t.bool(),
  clipsGround: __t.bool(),
});
export type Asset = __Infer<typeof Asset>;

export const AssetAttribute = __t.object("AssetAttribute", {
  attributeId: __t.u64(),
  assetId: __t.u64(),
  key: __t.string(),
  value: __t.string(),
  category: __t.string(),
});
export type AssetAttribute = __Infer<typeof AssetAttribute>;

export const AssetCanonicalNode = __t.object("AssetCanonicalNode", {
  rowId: __t.u64(),
  assetId: __t.u64(),
  canonicalId: __t.u64(),
  nodePath: __t.string(),
  name: __t.string(),
  translateX: __t.f64(),
  translateY: __t.f64(),
  translateZ: __t.f64(),
  rotateX: __t.f64(),
  rotateY: __t.f64(),
  rotateZ: __t.f64(),
  rotateW: __t.f64(),
  scaleX: __t.f64(),
  scaleY: __t.f64(),
  scaleZ: __t.f64(),
  get nodeType() {
    return SceneNodeType;
  },
  meshTriangleCount: __t.option(__t.u32()),
  sourceRenditionId: __t.u64(),
});
export type AssetCanonicalNode = __Infer<typeof AssetCanonicalNode>;

// The tagged union or sum type for the algebraic type `AssetCategory`.
export const AssetCategory = __t.enum("AssetCategory", {
  Model3D: __t.unit(),
  Icon: __t.unit(),
  Bim: __t.unit(),
  Pak: __t.unit(),
});
export type AssetCategory = __Infer<typeof AssetCategory>;

export const AssetChunkHashIndex = __t.object("AssetChunkHashIndex", {
  hash: __t.string(),
});
export type AssetChunkHashIndex = __Infer<typeof AssetChunkHashIndex>;

export const AssetChunkStore = __t.object("AssetChunkStore", {
  hash: __t.string(),
  sizeBytes: __t.u32(),
  referenceCount: __t.u32(),
  firstUploadedAt: __t.timestamp(),
  uploadedBy: __t.identity(),
});
export type AssetChunkStore = __Infer<typeof AssetChunkStore>;

export const AssetCreatedEvent = __t.object("AssetCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  assetId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetCreatedEvent = __Infer<typeof AssetCreatedEvent>;

export const AssetDispatchConfig = __t.object("AssetDispatchConfig", {
  id: __t.u32(),
  stdbToken: __t.string(),
  stdbHost: __t.string(),
  assetModuleName: __t.string(),
  updatedAt: __t.timestamp(),
});
export type AssetDispatchConfig = __Infer<typeof AssetDispatchConfig>;

export const AssetFile = __t.object("AssetFile", {
  fileId: __t.u64(),
  versionId: __t.u64(),
  filename: __t.string(),
  relativePath: __t.string(),
  isPrimary: __t.bool(),
  sizeBytes: __t.u64(),
  hash: __t.string(),
  contentType: __t.string(),
  blobPath: __t.string(),
  downloadUrl: __t.option(__t.string()),
  chunkSize: __t.u32(),
  chunkCount: __t.u32(),
});
export type AssetFile = __Infer<typeof AssetFile>;

export const AssetFileChunkRef = __t.object("AssetFileChunkRef", {
  refId: __t.u64(),
  fileId: __t.u64(),
  chunkIndex: __t.u32(),
  chunkHash: __t.string(),
});
export type AssetFileChunkRef = __Infer<typeof AssetFileChunkRef>;

export const AssetFileRegisteredEvent = __t.object("AssetFileRegisteredEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  fileId: __t.u64(),
  relativePath: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetFileRegisteredEvent = __Infer<typeof AssetFileRegisteredEvent>;

export const AssetImportSettings = __t.object("AssetImportSettings", {
  renditionId: __t.u64(),
  assetId: __t.u64(),
  settingsJson: __t.string(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type AssetImportSettings = __Infer<typeof AssetImportSettings>;

export const AssetIngestionCompletedEvent = __t.object("AssetIngestionCompletedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  assetId: __t.option(__t.u64()),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetIngestionCompletedEvent = __Infer<typeof AssetIngestionCompletedEvent>;

export const AssetIngestionRequest = __t.object("AssetIngestionRequest", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get status() {
    return IngestionStatus;
  },
  sourceUrl: __t.string(),
  targetModule: __t.string(),
  format: __t.string(),
  scope: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  error: __t.option(__t.string()),
  converter: __t.option(__t.string()),
  assetId: __t.u64(),
  sourceRenditionId: __t.u64(),
  operation: __t.option(__t.string()),
  jobDurationSecs: __t.u64(),
  geoOrigin: __t.option(__t.string()),
  progressStage: __t.option(__t.string()),
  progressPct: __t.option(__t.f32()),
});
export type AssetIngestionRequest = __Infer<typeof AssetIngestionRequest>;

export const AssetMetadata = __t.object("AssetMetadata", {
  metadataId: __t.u64(),
  versionId: __t.u64(),
  fileId: __t.u64(),
  key: __t.string(),
  value: __t.string(),
  get category() {
    return MetadataCategory;
  },
});
export type AssetMetadata = __Infer<typeof AssetMetadata>;

// The tagged union or sum type for the algebraic type `AssetPlacement`.
export const AssetPlacement = __t.enum("AssetPlacement", {
  TwinInstanced: __t.unit(),
  Scene: __t.unit(),
});
export type AssetPlacement = __Infer<typeof AssetPlacement>;

export const AssetProjectScope = __t.object("AssetProjectScope", {
  scope: __t.string(),
  projectId: __t.u32(),
  claimedAt: __t.timestamp(),
});
export type AssetProjectScope = __Infer<typeof AssetProjectScope>;

export const AssetRendition = __t.object("AssetRendition", {
  renditionId: __t.u64(),
  assetId: __t.u64(),
  format: __t.string(),
  get category() {
    return AssetCategory;
  },
  boundsMinX: __t.option(__t.f64()),
  boundsMinY: __t.option(__t.f64()),
  boundsMinZ: __t.option(__t.f64()),
  boundsMaxX: __t.option(__t.f64()),
  boundsMaxY: __t.option(__t.f64()),
  boundsMaxZ: __t.option(__t.f64()),
  currentVersionId: __t.option(__t.u64()),
  sourceRenditionId: __t.option(__t.u64()),
  createdAt: __t.timestamp(),
  correctionOffsetX: __t.f64(),
  correctionOffsetY: __t.f64(),
  correctionOffsetZ: __t.f64(),
  correctionYawDeg: __t.f64(),
  correctionPitchDeg: __t.f64(),
  correctionRollDeg: __t.f64(),
  correctionScaleX: __t.f64(),
  correctionScaleY: __t.f64(),
  correctionScaleZ: __t.f64(),
  geoOriginLon: __t.option(__t.f64()),
  geoOriginLat: __t.option(__t.f64()),
  geoOriginAlt: __t.option(__t.f64()),
  geoHeadingDeg: __t.option(__t.f64()),
  footprintGeojson: __t.option(__t.string()),
});
export type AssetRendition = __Infer<typeof AssetRendition>;

export const AssetRenditionCreatedEvent = __t.object("AssetRenditionCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  renditionId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetRenditionCreatedEvent = __Infer<typeof AssetRenditionCreatedEvent>;

export const AssetRenditionNode = __t.object("AssetRenditionNode", {
  rowId: __t.u64(),
  assetId: __t.u64(),
  renditionId: __t.u64(),
  canonicalId: __t.u64(),
  nodePath: __t.string(),
  translateX: __t.f64(),
  translateY: __t.f64(),
  translateZ: __t.f64(),
  rotateX: __t.f64(),
  rotateY: __t.f64(),
  rotateZ: __t.f64(),
  rotateW: __t.f64(),
  scaleX: __t.f64(),
  scaleY: __t.f64(),
  scaleZ: __t.f64(),
});
export type AssetRenditionNode = __Infer<typeof AssetRenditionNode>;

// The tagged union or sum type for the algebraic type `AssetRole`.
export const AssetRole = __t.enum("AssetRole", {
  NoRole: __t.unit(),
  User: __t.unit(),
  Admin: __t.unit(),
  Uploader: __t.unit(),
});
export type AssetRole = __Infer<typeof AssetRole>;

export const AssetSceneNode = __t.object("AssetSceneNode", {
  nodeId: __t.u64(),
  versionId: __t.u64(),
  fileId: __t.u64(),
  name: __t.string(),
  parentNodeId: __t.option(__t.u64()),
  nodePath: __t.string(),
  translateX: __t.f64(),
  translateY: __t.f64(),
  translateZ: __t.f64(),
  rotateX: __t.f64(),
  rotateY: __t.f64(),
  rotateZ: __t.f64(),
  rotateW: __t.f64(),
  scaleX: __t.f64(),
  scaleY: __t.f64(),
  scaleZ: __t.f64(),
  get nodeType() {
    return SceneNodeType;
  },
  meshTriangleCount: __t.option(__t.u32()),
});
export type AssetSceneNode = __Infer<typeof AssetSceneNode>;

export const AssetScopeGrant = __t.object("AssetScopeGrant", {
  grantId: __t.u64(),
  identity: __t.identity(),
  scope: __t.string(),
  get role() {
    return AssetScopeRole;
  },
  grantedAt: __t.timestamp(),
});
export type AssetScopeGrant = __Infer<typeof AssetScopeGrant>;

// The tagged union or sum type for the algebraic type `AssetScopeRole`.
export const AssetScopeRole = __t.enum("AssetScopeRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type AssetScopeRole = __Infer<typeof AssetScopeRole>;

export const AssetStorageConfig = __t.object("AssetStorageConfig", {
  id: __t.u32(),
  accountName: __t.string(),
  container: __t.string(),
  updatedAt: __t.timestamp(),
  blobOwner: __t.option(__t.string()),
});
export type AssetStorageConfig = __Infer<typeof AssetStorageConfig>;

export const AssetUploadCompletedEvent = __t.object("AssetUploadCompletedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  confirmed: __t.u32(),
  failed: __t.u32(),
  total: __t.u32(),
  createdAt: __t.timestamp(),
});
export type AssetUploadCompletedEvent = __Infer<typeof AssetUploadCompletedEvent>;

export const AssetUploadProgress = __t.object("AssetUploadProgress", {
  progressId: __t.u64(),
  userIdentity: __t.identity(),
  assetId: __t.u64(),
  versionId: __t.u64(),
  get status() {
    return UploadStatus;
  },
  totalFiles: __t.u32(),
  filesUploaded: __t.u32(),
  totalBytes: __t.u64(),
  bytesUploaded: __t.u64(),
  currentFile: __t.option(__t.string()),
});
export type AssetUploadProgress = __Infer<typeof AssetUploadProgress>;

export const AssetUploadProgressCreatedEvent = __t.object("AssetUploadProgressCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  progressId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetUploadProgressCreatedEvent = __Infer<typeof AssetUploadProgressCreatedEvent>;

export const AssetUser = __t.object("AssetUser", {
  identity: __t.identity(),
  get role() {
    return AssetRole;
  },
  createdAt: __t.timestamp(),
  lastConnectedAt: __t.timestamp(),
  isConnected: __t.bool(),
  get roleSource() {
    return RoleSource;
  },
});
export type AssetUser = __Infer<typeof AssetUser>;

export const AssetVersion = __t.object("AssetVersion", {
  versionId: __t.u64(),
  assetId: __t.u64(),
  version: __t.u32(),
  get status() {
    return VersionStatus;
  },
  releaseNotes: __t.string(),
  totalSizeBytes: __t.u64(),
  fileCount: __t.u32(),
  createdAt: __t.timestamp(),
  publishedAt: __t.option(__t.timestamp()),
  createdBy: __t.identity(),
  renditionId: __t.u64(),
});
export type AssetVersion = __Infer<typeof AssetVersion>;

export const AssetVersionCreatedEvent = __t.object("AssetVersionCreatedEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  versionId: __t.u64(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AssetVersionCreatedEvent = __Infer<typeof AssetVersionCreatedEvent>;

// The tagged union or sum type for the algebraic type `ClientType`.
export const ClientType = __t.enum("ClientType", {
  Unknown: __t.unit(),
  Webclient: __t.unit(),
  App: __t.unit(),
});
export type ClientType = __Infer<typeof ClientType>;

export const ConnectedClient = __t.object("ConnectedClient", {
  connectionId: __t.connectionId(),
  userIdentity: __t.identity(),
  get clientType() {
    return ClientType;
  },
  connectedAt: __t.timestamp(),
});
export type ConnectedClient = __Infer<typeof ConnectedClient>;

export const InfraBrokerConfig = __t.object("InfraBrokerConfig", {
  id: __t.u32(),
  brokerUrl: __t.string(),
  configuredAt: __t.timestamp(),
});
export type InfraBrokerConfig = __Infer<typeof InfraBrokerConfig>;

// The tagged union or sum type for the algebraic type `IngestionStatus`.
export const IngestionStatus = __t.enum("IngestionStatus", {
  Pending: __t.unit(),
  Building: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type IngestionStatus = __Infer<typeof IngestionStatus>;

export const IngestionWatchdogSchedule = __t.object("IngestionWatchdogSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type IngestionWatchdogSchedule = __Infer<typeof IngestionWatchdogSchedule>;

// The tagged union or sum type for the algebraic type `MetadataCategory`.
export const MetadataCategory = __t.enum("MetadataCategory", {
  General: __t.unit(),
  Geometry: __t.unit(),
  Material: __t.unit(),
  Animation: __t.unit(),
  Scene: __t.unit(),
  Geospatial: __t.unit(),
  Bim: __t.unit(),
});
export type MetadataCategory = __Infer<typeof MetadataCategory>;

// The tagged union or sum type for the algebraic type `ModuleRole`.
export const ModuleRole = __t.enum("ModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type ModuleRole = __Infer<typeof ModuleRole>;

export const ModuleServiceConfig = __t.object("ModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type ModuleServiceConfig = __Infer<typeof ModuleServiceConfig>;

export const ModuleUser = __t.object("ModuleUser", {
  identity: __t.identity(),
  get role() {
    return ModuleRole;
  },
});
export type ModuleUser = __Infer<typeof ModuleUser>;

export const OrgModuleAdminLineage = __t.object("OrgModuleAdminLineage", {
  id: __t.u32(),
  mintedBy: __t.identity(),
});
export type OrgModuleAdminLineage = __Infer<typeof OrgModuleAdminLineage>;

// The tagged union or sum type for the algebraic type `OrgModuleRole`.
export const OrgModuleRole = __t.enum("OrgModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type OrgModuleRole = __Infer<typeof OrgModuleRole>;

export const OrgModuleServiceConfig = __t.object("OrgModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type OrgModuleServiceConfig = __Infer<typeof OrgModuleServiceConfig>;

export const OrgModuleUser = __t.object("OrgModuleUser", {
  identity: __t.identity(),
  get role() {
    return OrgModuleRole;
  },
});
export type OrgModuleUser = __Infer<typeof OrgModuleUser>;

export const PostRestoreMarker = __t.object("PostRestoreMarker", {
  id: __t.u32(),
  ranAt: __t.timestamp(),
});
export type PostRestoreMarker = __Infer<typeof PostRestoreMarker>;

export const ProjectScopeConfig = __t.object("ProjectScopeConfig", {
  id: __t.u32(),
  projectName: __t.string(),
  configuredAt: __t.timestamp(),
  allowedScopes: __t.option(__t.array(__t.string())),
});
export type ProjectScopeConfig = __Infer<typeof ProjectScopeConfig>;

export const ProjectTenantConfig = __t.object("ProjectTenantConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  isPublic: __t.bool(),
  configuredAt: __t.timestamp(),
});
export type ProjectTenantConfig = __Infer<typeof ProjectTenantConfig>;

export const RenderCreditLedger = __t.object("RenderCreditLedger", {
  project: __t.string(),
  accruedCredits: __t.u64(),
  reportedCredits: __t.u64(),
});
export type RenderCreditLedger = __Infer<typeof RenderCreditLedger>;

export const RenderJob = __t.object("RenderJob", {
  id: __t.u64(),
  project: __t.string(),
  requestedBy: __t.identity(),
  get status() {
    return RenderStatus;
  },
  prompt: __t.string(),
  style: __t.string(),
  contextJson: __t.string(),
  quality: __t.string(),
  size: __t.string(),
  sourceBlobPath: __t.string(),
  blobPath: __t.string(),
  error: __t.string(),
  costUsdMilli: __t.u64(),
  requestedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type RenderJob = __Infer<typeof RenderJob>;

// The tagged union or sum type for the algebraic type `RenderStatus`.
export const RenderStatus = __t.enum("RenderStatus", {
  Pending: __t.unit(),
  Rendering: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type RenderStatus = __Infer<typeof RenderStatus>;

export const RenditionPreference = __t.object("RenditionPreference", {
  clientType: __t.string(),
  formats: __t.array(__t.string()),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type RenditionPreference = __Infer<typeof RenditionPreference>;

export const ReportUsageConfig = __t.object("ReportUsageConfig", {
  id: __t.u32(),
  reportUrl: __t.string(),
  secret: __t.string(),
  billingOwnerId: __t.string(),
  sourceDb: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ReportUsageConfig = __Infer<typeof ReportUsageConfig>;

// The tagged union or sum type for the algebraic type `RoleSource`.
export const RoleSource = __t.enum("RoleSource", {
  Claim: __t.unit(),
  Manual: __t.unit(),
  Scope: __t.unit(),
});
export type RoleSource = __Infer<typeof RoleSource>;

// The tagged union or sum type for the algebraic type `SceneNodeType`.
export const SceneNodeType = __t.enum("SceneNodeType", {
  Xform: __t.unit(),
  Mesh: __t.unit(),
  Camera: __t.unit(),
  Light: __t.unit(),
  Group: __t.unit(),
  Other: __t.unit(),
});
export type SceneNodeType = __Infer<typeof SceneNodeType>;

export const ScopeBlobReclaim = __t.object("ScopeBlobReclaim", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  scope: __t.string(),
  blobPaths: __t.array(__t.string()),
});
export type ScopeBlobReclaim = __Infer<typeof ScopeBlobReclaim>;

export const ScopeUsageLedger = __t.object("ScopeUsageLedger", {
  scope: __t.string(),
  egressBytes: __t.u128(),
  blobStorageByteSeconds: __t.u128(),
  curBlobStorageBytes: __t.u128(),
  vcpuSeconds: __t.u128(),
  gibSeconds: __t.u128(),
  lastTickMs: __t.i64(),
});
export type ScopeUsageLedger = __Infer<typeof ScopeUsageLedger>;

export const SourceCurrentVersion = __t.object("SourceCurrentVersion", {
  assetId: __t.u64(),
  renditionId: __t.u64(),
  format: __t.string(),
  currentVersionId: __t.u64(),
});
export type SourceCurrentVersion = __Infer<typeof SourceCurrentVersion>;

// The tagged union or sum type for the algebraic type `UploadStatus`.
export const UploadStatus = __t.enum("UploadStatus", {
  Scanning: __t.unit(),
  Uploading: __t.unit(),
  Finalizing: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type UploadStatus = __Infer<typeof UploadStatus>;

export const UsageFlushSchedule = __t.object("UsageFlushSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type UsageFlushSchedule = __Infer<typeof UsageFlushSchedule>;

// The tagged union or sum type for the algebraic type `VersionStatus`.
export const VersionStatus = __t.enum("VersionStatus", {
  Draft: __t.unit(),
  Published: __t.unit(),
  Deprecated: __t.unit(),
});
export type VersionStatus = __Infer<typeof VersionStatus>;

export const WorkosOrgConfig = __t.object("WorkosOrgConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  configuredAt: __t.timestamp(),
});
export type WorkosOrgConfig = __Infer<typeof WorkosOrgConfig>;

